<template>
		<div>
			<div>
				<h3>Offset from Schedule Start</h3>
				<button @click="resetWindow(1)" title="Reset" class="btn">Reset</button>
			</div>
			<div class="offset-div">
				<label>Months</label>
				<input id="windef-1-start-months" type="number" class="schedule-width curved-border extra-padding-text-fields">
				<label>Days</label>
				<input id="windef-1-start-days" type="number" class="schedule-width curved-border extra-padding-text-fields">
				<label>Hours</label>
				<input id="windef-1-start-hours" type="number" class="schedule-width curved-border extra-padding-text-fields">
				<label>Minutes</label>
				<input id="windef-1-start-minutes" type="number" class="schedule-width curved-border extra-padding-text-fields">
				<label>Exclude</label>
				<select class="curved-border extra-padding-text-fields" id="windef-1-start-exclude" title="Cycle Duration" multiple> 
					<option>Sunday</option>
					<option>Monday</option>
					<option>Tuesday</option>
					<option>Wednesday</option>
					<option>Thursday</option>
					<option>Friday</option>
					<option>Saturday</option>
				</select>
				<div class="find-relative-div">
					<p>Or pick a date/time to compute</p>
					<input class="curved-border extra-padding-text-fields" v-model="relativeStartDate" id="windef-1-relative-start-date" type="datetime-local">
					<button class="btn" @click="findRelative(1)">Find Relative</button>
					<p v-if="dateLessThanStartDate" class="warning-text">Your Find Relative date is before the start date</p>
				</div>
			</div>
			<div>
				<h3>Duration - window</h3>
				<p class="warning">One of the fields below must be filled for duration</p>
				<p>Click Add Window to add one window to the schedule and click create to create a schedule with the windows you have added so far</p>
			</div>
			<div>
				<label>Months</label>
				<input id="windef-1-dur-months"  type="number" class="schedule-width curved-border extra-padding-text-fields">
				<label>Days</label>
				<input id="windef-1-dur-days"  type="number" class="schedule-width curved-border extra-padding-text-fields">
				<label>Hours</label>
				<input id="windef-1-dur-hours"  type="number" class="schedule-width curved-border extra-padding-text-fields">
				<label>Minutes</label>
				<input id="windef-1-dur-minutes"  type="number" class="schedule-width curved-border extra-padding-text-fields">
			</div>
			<div>
				<button class="btn" @click="addWindow()">Add Window</button>
			</div>
		</div>
</template>

<script>
export default {
	name: "Schedule",
	props: {
		scheduleStartDate: Object,
		cycleDurationNumber: Number,
		cycleDurationUnit: String,
		adminState: Object
	},
	data() {
		return {
			relativeStartDate: null,
			serverBusy: false,
			status: Object.assign({}, this.globalStatus),
			maxAmountOfSchedules: 3,
			cycleData:[],
			listOfCycles:[],
			calendarDataLoaded: false,
			schedule: null,
			windows:[],
			dateLessThanStartDate: false,
		};
	},
	watch:{
		relativeStartDate() {
			if(new Date(this.relativeStartDate) < new Date(this.scheduleStartDate)) this.dateLessThanStartDate = true;
			else{ this.dateLessThanStartDate = false;}
		}
	},
	methods: {

		addWindow() {
			let window = this.buildWindowDefFromInput(1);
			if(window == undefined) return;
			this.eventBus.emit("addWindow", window);
			this.resetWindow(1);
		},

		getCycleDuration() {
			const durationUnit = this.cycleDurationUnit;
			const durationValue = this.cycleDurationNumber;

			const durationObj = {};
			durationObj[durationUnit] = Number(durationValue);

			return durationObj;
		},
		buildWindowDefFromInput(windDefIndex) {

			const prefix = `windef-${windDefIndex}-`;

			let windDef = {
				windowStart:{},
				windowDuration:{}
			};
		   
			windDef.windowStart.months = Number(document.getElementById(prefix+"start-months").value);
			windDef.windowStart.days = Number(document.getElementById(prefix+"start-days").value);
			windDef.windowStart.hours = Number(document.getElementById(prefix+"start-hours").value);
			windDef.windowStart.minutes = Number(document.getElementById(prefix+"start-minutes").value);

			windDef.windowStart.excludeDays = Array.from(document.getElementById(prefix + "start-exclude").selectedOptions).map(option => option.innerText).join();

			windDef.windowDuration.months = Number(document.getElementById(prefix+"dur-months").value);
			windDef.windowDuration.days = Number(document.getElementById(prefix+"dur-days").value);
			windDef.windowDuration.hours = Number(document.getElementById(prefix+"dur-hours").value);
			windDef.windowDuration.minutes = Number(document.getElementById(prefix+"dur-minutes").value);

			if(windDef.windowDuration.months== 0 && windDef.windowDuration.days== 0 && windDef.windowDuration.hours== 0 && windDef.windowDuration.minutes == 0){
				this.status.message = "You must fill out one of the duration fields to create a window";
				this.status.ok = false;
				this.eventBus.emit("updateStatus", this.status);
				return;
			}

			return windDef;
		},

		async findRelative(windowIndex) {

			 if(this.scheduleStartDate == null){
				this.status.message = "You need to have a cycle start date to create a schedule";
				this.status.ok = false;
				this.eventBus.emit("updateStatus", this.status);
				return;
			}
			if(this.cycleDurationNumber == null){
				this.status.message = "You need to have a cycle duration number to create a schedule";
				this.status.ok = false;
				this.eventBus.emit("updateStatus", this.status);
				return;
			}
			if(this.cycleDurationUnit == null){
				this.status.message = "You need to have a cycle duration unit to create a schedule";
				this.status.ok = false;
				this.eventBus.emit("updateStatus", this.status);
				return;
			}
			const prefix  = `windef-${windowIndex}-`;
			const targetDate = new Date(document.getElementById(prefix + "relative-start-date").value);
			
			if(targetDate < new Date(this.scheduleStartDate)){
				this.status.message = "Relative Date cannot be before cycle start date" ;
				this.status.ok = false;
				this.eventBus.emit("updateStatus", this.status);
				return;
			}

			let body = {
				startDate: new Date(this.scheduleStartDate).toISOString(),
				targetDate: targetDate.toISOString(),
				cycleDuration: this.getCycleDuration(),
			};

			let requestUrl = new URL("/api/v1/schedule/diff", this.rabbitsfootHostUrl);
			let headerObj = new Headers();
			headerObj.append("Authorization", `Bearer ${this.adminState.accessToken}`);
			headerObj.append("Content-Type", "application/json; charset=utf-8");
			let request = new Request(requestUrl.toString(), {
				method: "POST",
				body: JSON.stringify(body),
				headers: headerObj,
			});

			try {
				let response = (await fetch(request).then(test => test.json()));
				let relativeTime = response.relativeTime;
				this.populateWindowFields(1,relativeTime);
			}
			catch(e){
				this.status.code = e;
				this.status.ok = false;
				this.eventBus.emit("updateStatus", this.status);
				console.log("there was an error", e);
			}
		},

		populateWindowFields(windowIndex,start,duration,reset){
			let prefix = `windef-${windowIndex}-`;

			if(start){
				document.getElementById(prefix + "start-months").value = start.months ?? null;
				document.getElementById(prefix + "start-days").value = start.days ?? null;
				document.getElementById(prefix + "start-hours").value = start.hours ?? null;
				document.getElementById(prefix + "start-minutes").value = start.minutes ?? null;
				document.getElementById(prefix +"relative-start-date").value = null;

				if(reset) {
					let excludeString = start.excludeDays ?? "";
					let excludeDays = document.getElementById(prefix + "start-exclude");
					for (let opt of excludeDays.options){
						opt.selected = (excludeString.indexOf(opt.innerText) > -1);
					}
				}				
			}

			if(duration) {
				document.getElementById(prefix + "dur-months").value = duration.months ?? null;
				document.getElementById(prefix + "dur-days").value = duration.days ?? null;
				document.getElementById(prefix + "dur-hours").value = duration.hours ?? null;
				document.getElementById(prefix + "dur-minutes").value = duration.minutes ?? null;
			}
		},

		resetWindow(windowIndex) {
			let offest = {};
			let duration = {days: null};
			this.populateWindowFields(windowIndex,offest,duration,true);
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.header {
	position: relative;
}

.scheduler {
	display: flex;
	position: relative;
	text-align: center;
	flex-direction: column;
	align-items: center;
	margin-top: 5%;
	
}

.schedule-width {
	width: 45px;
	height: 20px;
}

.scheduler-height {
	height: 250vh;
}


.curved-border {
	border-radius: 5px !important;
	-webkit-border-radius: 5px !important;
}

.extra-padding-text-fields {
	padding: 2px 15px;
}

.cycle-duration-width {
	width: 45px;
}

.calendar-section {
	display: flex;
	flex-direction: row;
}

option:checked {
	background: #5b88c0;
	color: white;
}

button {
	width: 135px;
	height: 30px;
}

hr {
	display: block;
	height: 1px;
	border: 0;
	border-top: 2px solid white;
	margin: 1em 0;
	padding: 0;
}

.required:before {
	content: "*";
	color: red;
}

.warning {
	color: yellow;
}

.find-relative-div {
	display: inline;
}

.offset-div {
	margin-bottom: 5vh;
}
.warning-text {
	color: red;
}

</style>